module.exports = __webpack_public_path__ + "img/activity-adrenaline.bc15cf14.jpg";